import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC, ReactElement, useState } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { BUTTON_TITLE } from 'src/constants/main';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import Icon from 'src/view/components/Controls/Icon/Icon';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { modalStore } from '~/mobx/modalStore';
import './style.scss';

export interface IAskAgainModalSubmit {
  isConfirm: boolean;
  checkBoxStatus: boolean;
  close: boolean;
}

export interface IAskAgainModal {
  message: string;
  checkboxName?: string;
  checkboxLabel?: string;
  checkBoxStatus?: boolean;
  submit: ({ isConfirm, checkBoxStatus, close }: IAskAgainModalSubmit) => void;
  iconName?: Icons;
  iconSize?: number;
  iconColor?: string;
  className?: string;
}

export const AskAgainModal: FC<IAskAgainModal> = observer(
  ({
    checkboxName = 'askAgain',
    checkboxLabel = 'dont_ask_again',
    checkBoxStatus: propsCheckboxStatus = false,
    iconName = Icons.ReverseArrows,
    iconSize = 100,
    iconColor = theme.colors.mainblue,
    ...props
  }: IAskAgainModal): ReactElement => {
    const [checkBoxStatus, setCheckBoxStatus] = useState<boolean>(propsCheckboxStatus);

    const changeStatus = () => {
      setCheckBoxStatus(!checkBoxStatus);
    };

    return (
      <CustomModalComponent
        isOpen={Boolean(modalStore.askAgainModal)}
        onRequestClose={() => props.submit({ isConfirm: false, checkBoxStatus, close: true })}
        className={classNames('ask-again-modal', props.className)}
        overlayClassName="ask-again-modal__overlay"
      >
        <ModalBackground className="d-flex flex-column align-items-center p-6">
          <Icon name={iconName} size={iconSize} color={iconColor} className="ask-again-modal__icon" />
          <Text type={TEXT.CUSTOM} text={props.message} className="ask-again-modal__text family-semibold text-size-20 mt-6 mb-3" />
          <Checkbox name={checkboxName} label={checkboxLabel} value={checkBoxStatus} onClick={changeStatus} />
          <div className="d-flex flex-row justify-content-center full-width mt-8 gap-10">
            <Button
              title={localeStore.t(BUTTON_TITLE.YES)}
              onClick={() => props.submit({ isConfirm: true, checkBoxStatus, close: false })}
              stretched
            />
            <Button
              title={localeStore.t(BUTTON_TITLE.NO)}
              onClick={() => props.submit({ isConfirm: false, checkBoxStatus, close: false })}
              appearance="tertiary"
              stretched
            />
          </div>
        </ModalBackground>
      </CustomModalComponent>
    );
  }
);
